import { Button, HStack } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserContext } from '../context/UserContextProvider';

function LanguageSwitch() {
  const { i18n } = useTranslation();
  const userContext = useUserContext();
  const userLanguage = userContext.user?.language;
  const [cimode, setCimode] = useState(false);
  return (
    <HStack>
      <Button
        onClick={() => {
          setCimode(!cimode);
          i18n.changeLanguage(cimode ? userLanguage : 'cimode');
        }}
      >
        {cimode ? `Toggle ${userLanguage}` : 'Toggle Cimode'}
      </Button>
    </HStack>
  );
}

export default LanguageSwitch;
